import Menu from "./Menu";
import MenuItem from "./MenuItem";
import MenuCollapse from "./MenuCollapse";

Menu.MenuItem = MenuItem;
Menu.MenuCollapse = MenuCollapse;

export default Menu;
